<template>
  <div>
    <h2>当前页面不存在</h2>
  </div>
</template>

<script>
export default {
  name: "ErrorPage"
}
</script>

<style scoped>

</style>
